import { ArrowRight } from "lucide-react";
import { SIGNUP_TEXT } from "../../domain/constants/constants";
import { styles as s } from "../../styles/signupstyles";

type Props = {
  disabled: boolean;
  onClick: () => void;
};

export default function ContinueButton({
  disabled,
  onClick,
}: Props) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`${s.continueButton} ${
        disabled
          ? s.continueDisabled
          : s.continueActive
      }`}
    >
      {SIGNUP_TEXT.continue}

      <ArrowRight size={20} />
    </button>
  );
}